package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.FinancialRepository
import com.evoapps.evoshift.domain.repository.ShiftRepository
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.drop
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.merge

/**
 * SH-188: "something of this month changed": its shifts (an assignment, a swap taken, a
 * clock-in, here or on another device) or, for those who read money, its totals
 * (roster_financials, which the server recomputes after takings or costs are written). Emits
 * after each change, never for the current state, so a screen that read the month once reads it
 * again only when there is something new. Errors (a refused listener) reach the collector.
 */
class ObserveRosterChangesUseCase(
    private val financialRepository: FinancialRepository,
    private val shiftRepository: ShiftRepository
) {
    operator fun invoke(rosterId: String, includeFinances: Boolean): Flow<Unit> {
        val shifts = shiftRepository.observeShiftsForRoster(rosterId).drop(1).map { }
        if (!includeFinances) return shifts
        val totals = financialRepository.observeRosterFinancials(rosterId).distinctUntilChanged().drop(1).map { }
        return merge(shifts, totals)
    }
}
